/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_TitleInputs */

const en_us2_workout_logging_kind_title = /** @type {(inputs: Workout_Logging_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set type`)
};

const pt_br2_workout_logging_kind_title = /** @type {(inputs: Workout_Logging_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de série`)
};

const es_419_workout_logging_kind_title = /** @type {(inputs: Workout_Logging_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de serie`)
};

const pt_pt2_workout_logging_kind_title = /** @type {(inputs: Workout_Logging_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de série`)
};

const fr_fr2_workout_logging_kind_title = /** @type {(inputs: Workout_Logging_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de série`)
};

const de_de2_workout_logging_kind_title = /** @type {(inputs: Workout_Logging_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satzart`)
};

const it_it2_workout_logging_kind_title = /** @type {(inputs: Workout_Logging_Kind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di serie`)
};

/**
* | output |
* | --- |
* | "Set type" |
*
* @param {Workout_Logging_Kind_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_title = /** @type {((inputs?: Workout_Logging_Kind_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_title(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_title(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_title(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_title(inputs)
	return en_us2_workout_logging_kind_title(inputs)
});
export { workout_logging_kind_title as "workout-logging.kind_title" }